import React from 'react'
import {bindAll, isEmpty} from 'lodash'
import Checkbox from '../Checkbox'
import * as constant from '../contants'
import Fade from '../../Utils/Fade'

const questionName = constant.INSURANCE

export default class Insurance extends React.PureComponent {
    constructor(props) {
        super(props)

        let answer = this.getCurrentAnswer(this.props)
        if (isEmpty(answer)) answer = this.initAnswer()
        this.state = {
            checkedCommercial: answer.options.checkedCommercial,
            checkedPartA: answer.options.checkedPartA,
            checkedPartAB: answer.options.checkedPartAB,
            checkedPartABD: answer.options.checkedPartABD,
            checkedMedicaid: answer.options.checkedMedicaid,
            checkedOther: answer.options.checkedOther,
            checkedNone: answer.options.checkedNone,
            checkedCommercialYes: answer.options.checkedCommercialYes,
            checkedCommercialNo: answer.options.checkedCommercialNo,
            checkedPartABDYes: answer.options.checkedPartABDYes,
            checkedPartABDNo: answer.options.checkedPartABDNo,
            checkedPartABDSubYes: answer.options.checkedPartABDSubYes,
            checkedPartABDSubNo: answer.options.checkedPartABDSubNo,
            checkedPartABDSub2Yes: answer.options.checkedPartABDSub2Yes,
            checkedPartABDSub2No: answer.options.checkedPartABDSub2No,
            mainAnswers: this.props.answers,
        }
        bindAll(this, ['calculateNecessaryIncome', 'getCurrentAnswer', 'setCheckedCommercial', 'setCheckedPartA', 'setCheckedPartAB',
            'setCheckedPartABD', 'setCheckedMedicaid', 'setCheckedOther', 'setCheckedNone',
            'setCheckedCommercialYes', 'setCheckedCommercialNo', 'setCheckedPartABDYes', 'setCheckedPartABDNo', 'setToParentState',
            'setCheckedPartABDSubYes', 'setCheckedPartABDSubNo', 'setCheckedPartABDSub2Yes', 'setCheckedPartABDSub2No'])
    }


    componentWillReceiveProps(props) {
        let answer = this.getCurrentAnswer(props)
        if (isEmpty(answer)) answer = this.initAnswer()
        this.setState({
            checkedCommercial: answer.options.checkedCommercial,
            checkedPartA: answer.options.checkedPartA,
            checkedPartAB: answer.options.checkedPartAB,
            checkedPartABD: answer.options.checkedPartABD,
            checkedMedicaid: answer.options.checkedMedicaid,
            checkedOther: answer.options.checkedOther,
            checkedNone: answer.options.checkedNone,
            checkedCommercialYes: answer.options.checkedCommercialYes,
            checkedCommercialNo: answer.options.checkedCommercialNo,
            checkedPartABDYes: answer.options.checkedPartABDYes,
            checkedPartABDNo: answer.options.checkedPartABDNo,
            checkedPartABDSubYes: answer.options.checkedPartABDSubYes,
            checkedPartABDSubNo: answer.options.checkedPartABDSubNo,
            checkedPartABDSub2Yes: answer.options.checkedPartABDSub2Yes,
            checkedPartABDSub2No: answer.options.checkedPartABDSub2No,
        })
    }

    getCurrentAnswer(props) {
        const {answers} = props
        let currentAnswer = {}
        answers.forEach(answer => {
            if (answer.name === questionName) {
                currentAnswer = answer
            }
        })
        return currentAnswer
    }

    initAnswer() {
        return {
            name: questionName,
            options: {
                checkedCommercial: false,
                checkedPartA: false,
                checkedPartAB: false,
                checkedPartABD: false,
                checkedMedicaid: false,
                checkedOther: false,
                checkedNone: false,
                checkedCommercialYes: false,
                checkedCommercialNo: false,
                checkedPartABDYes: false,
                checkedPartABDNo: false,
                checkedPartABDSubYes: false,
                checkedPartABDSubNo: false,
                checkedPartABDSub2Yes: false,
                checkedPartABDSub2No: false,
            }
        }
    }

    calculateNecessaryIncome() {
        const mainAnswers = this.state.mainAnswers;
        const householdAnswer = mainAnswers.filter(function(answer) {
            return answer.name === 'HouseholdSize'
        })[0];
        const residencyAnswer = mainAnswers.filter(function(answer) {
            return answer.name === 'Residency'
        })[0];
        
        const householdSize = householdAnswer.options.checkedValue;
        
        let matrix = this.props.eligibleData.incomeMatrix;

        
        if (residencyAnswer.options.qualification.checkedAlaska) {
            matrix = matrix.Alaska;
        } else if (residencyAnswer.options.qualification.checkedContinental) {
            matrix = matrix.Continental;
        } else if (residencyAnswer.options.qualification.checkedHawaii) {
            matrix = matrix.Hawaii;
        }


        return matrix[householdSize] ? matrix[householdSize] : "$22,590?";
    }

    setCheckedCommercial(checkedCommercial) {
        this.setState({checkedCommercial})
        this.setToParentState(
            [
                {value: checkedCommercial, key: 'checkedCommercial'},
                {value: false, key: 'checkedCommercialYes'},
                {value: false, key: 'checkedCommercialNo'},
            ]
        )
    }

    setCheckedPartA(checkedPartA) {
        this.setState({checkedPartA})
        this.setToParentState([{value: checkedPartA, key: 'checkedPartA'}])
    }

    setCheckedPartAB(checkedPartAB) {
        this.setState({checkedPartAB})
        this.setToParentState([{value: checkedPartAB, key: 'checkedPartAB'}])
    }

    setCheckedPartABD(checkedPartABD) {
        this.setState({checkedPartABD})
        this.setToParentState(
            [
                {value: checkedPartABD, key: 'checkedPartABD'},
                {value: false, key: 'checkedPartABDYes'},
                {value: false, key: 'checkedPartABDNo'},
                {value: false, key: 'checkedPartABDSubYes'},
                {value: false, key: 'checkedPartABDSubNo'},
                {value: false, key: 'checkedPartABDSub2Yes'},
                {value: false, key: 'checkedPartABDSub2No'}
            ]
        )
    }

    setCheckedMedicaid(checkedMedicaid) {
        this.setState({checkedMedicaid})
        this.setToParentState([{value: checkedMedicaid, key: 'checkedMedicaid'}])
    }

    setCheckedOther(checkedOther) {
        this.setState({checkedOther})
        this.setToParentState([{value: checkedOther, key: 'checkedOther'}])
    }

    setCheckedNone(checkedNone) {
        this.setState({checkedNone})
        this.setToParentState([{value: checkedNone, key: 'checkedNone'}])
    }

    setCheckedCommercialYes(checkedCommercialYes) {
        let checkedCommercialNo = this.state.checkedCommercialNo
        if (checkedCommercialYes) checkedCommercialNo = false
        this.setState({checkedCommercialYes, checkedCommercialNo})
        this.setToParentState(
            [
                {value: checkedCommercialYes, key: 'checkedCommercialYes'},
                {value: checkedCommercialNo, key: 'checkedCommercialNo'}
            ]
        )
    }

    setCheckedCommercialNo(checkedCommercialNo) {
        let checkedCommercialYes = this.state.checkedCommercialYes
        if (checkedCommercialNo) checkedCommercialYes = false
        this.setState({checkedCommercialYes, checkedCommercialNo})
        this.setToParentState(
            [
                {value: checkedCommercialYes, key: 'checkedCommercialYes'},
                {value: checkedCommercialNo, key: 'checkedCommercialNo'}
            ]
        )
    }

    setCheckedPartABDYes(checkedPartABDYes) {
        let checkedPartABDNo = this.state.checkedPartABDNo
        if (checkedPartABDYes) checkedPartABDNo = false
        this.setState({checkedPartABDYes, checkedPartABDNo})
        this.setToParentState(
            [
                {value: checkedPartABDYes, key: 'checkedPartABDYes'},
                {value: checkedPartABDNo, key: 'checkedPartABDNo'},
                {value: false, key: 'checkedPartABDSubYes'},
                {value: false, key: 'checkedPartABDSubNo'},
                {value: false, key: 'checkedPartABDSub2Yes'},
                {value: false, key: 'checkedPartABDSub2No'},
            ]
        )
    }

    setCheckedPartABDNo(checkedPartABDNo) {
        let checkedPartABDYes = this.state.checkedPartABDYes
        if (checkedPartABDNo) checkedPartABDYes = false
        this.setState({checkedPartABDYes, checkedPartABDNo})
        this.setToParentState(
            [
                {value: checkedPartABDYes, key: 'checkedPartABDYes'},
                {value: checkedPartABDNo, key: 'checkedPartABDNo'},
                {value: false, key: 'checkedPartABDSub2Yes'},
                {value: false, key: 'checkedPartABDSub2No'},
            ]
        )
    }

    setCheckedPartABDSubYes(checkedPartABDSubYes) {
        let checkedPartABDSubNo = this.state.checkedPartABDSubNo
        if (checkedPartABDSubYes) checkedPartABDSubNo = false
        this.setState({checkedPartABDSubYes, checkedPartABDSubNo})
        this.setToParentState(
            [
                {value: checkedPartABDSubYes, key: 'checkedPartABDSubYes'},
                {value: checkedPartABDSubNo, key: 'checkedPartABDSubNo'},
                {value: false, key: 'checkedPartABDSub2Yes'},
                {value: false, key: 'checkedPartABDSub2No'},
            ]
        )
    }

    setCheckedPartABDSubNo(checkedPartABDSubNo) {
        let checkedPartABDSubYes = this.state.checkedPartABDSubYes
        if (checkedPartABDSubNo) checkedPartABDSubYes = false
        this.setState({checkedPartABDSubYes, checkedPartABDSubNo})
        this.setToParentState(
            [
                {value: checkedPartABDSubYes, key: 'checkedPartABDSubYes'},
                {value: checkedPartABDSubNo, key: 'checkedPartABDSubNo'},
                {value: false, key: 'checkedPartABDSub2Yes'},
                {value: false, key: 'checkedPartABDSub2No'},
            ]
        )
    }

    setCheckedPartABDSub2Yes(checkedPartABDSub2Yes) {
        let checkedPartABDSub2No = this.state.checkedPartABDSub2No
        if (checkedPartABDSub2Yes) checkedPartABDSub2No = false
        this.setState({checkedPartABDSub2Yes, checkedPartABDSub2No})
        this.setToParentState(
            [
                {value: checkedPartABDSub2Yes, key: 'checkedPartABDSub2Yes'},
                {value: checkedPartABDSub2No, key: 'checkedPartABDSub2No'}
            ]
        )
    }

    setCheckedPartABDSub2No(checkedPartABDSub2No) {
        let checkedPartABDSub2Yes = this.state.checkedPartABDSub2Yes
        if (checkedPartABDSub2No) checkedPartABDSub2Yes = false
        this.setState({checkedPartABDSub2Yes, checkedPartABDSub2No})
        this.setToParentState(
            [
                {value: checkedPartABDSub2Yes, key: 'checkedPartABDSub2Yes'},
                {value: checkedPartABDSub2No, key: 'checkedPartABDSub2No'}
            ]
        )
    }

    setToParentState(values) {
        let {
            checkedCommercial, checkedPartA, checkedPartAB, checkedPartABD,
            checkedMedicaid, checkedOther, checkedNone, checkedCommercialYes,
            checkedCommercialNo, checkedPartABDYes, checkedPartABDNo, checkedPartABDSubYes,
            checkedPartABDSubNo, checkedPartABDSub2Yes, checkedPartABDSub2No
        } = this.state
        let answer = {
            name: questionName,
            options: {
                checkedCommercial: checkedCommercial,
                checkedPartA: checkedPartA,
                checkedPartAB: checkedPartAB,
                checkedPartABD: checkedPartABD,
                checkedMedicaid: checkedMedicaid,
                checkedOther: checkedOther,
                checkedNone: checkedNone,
                checkedCommercialYes: checkedCommercialYes,
                checkedCommercialNo: checkedCommercialNo,
                checkedPartABDYes: checkedPartABDYes,
                checkedPartABDNo: checkedPartABDNo,
                checkedPartABDSubYes: checkedPartABDSubYes,
                checkedPartABDSubNo: checkedPartABDSubNo,
                checkedPartABDSub2Yes: checkedPartABDSub2Yes,
                checkedPartABDSub2No: checkedPartABDSub2No
            }
        }
        values.forEach(function (item) {
            answer.options[item.key] = item.value
        })
        this.props.setAnswers(answer)
    }

    render() {
        const {
            checkedCommercial, checkedPartA, checkedPartAB, checkedPartABD,
            checkedMedicaid, checkedOther, checkedNone, checkedCommercialYes,
            checkedCommercialNo, checkedPartABDYes, checkedPartABDNo, checkedPartABDSubYes,
            checkedPartABDSubNo, checkedPartABDSub2Yes, checkedPartABDSub2No
        } = this.state
        const {group, eligibleData} = this.props
        return (
            <div>
                {
                    !isEmpty(eligibleData) ?
                        <Fade duration={0.5}>
                            <h1 className="question-title text-center">
                                {eligibleData.question}
                            </h1>
                            <div className="question-content">
                                <div
                                    className={checkedCommercial ? "question-sub-content checked" : "question-sub-content"}>
                                    <Checkbox
                                        title={eligibleData.options[0].title}
                                        checked={checkedCommercial}
                                        clickHandler={this.setCheckedCommercial}
                                    />
                                    <div className="clearfix"/>
                                    {
                                        checkedCommercial ?
                                            <div className="qualification-content wow fadeInDown"
                                                 data-wow-duration=".5s">
                                                <h1 className="question-title text-center">
                                                    {eligibleData.options[0].sub.question}
                                                </h1>
                                                <div className="question-content">
                                                    <Checkbox
                                                        title={eligibleData.options[0].sub.options[0].title}
                                                        checked={checkedCommercialYes}
                                                        clickHandler={this.setCheckedCommercialYes}
                                                    />
                                                    <Checkbox
                                                        title={eligibleData.options[0].sub.options[1].title}
                                                        checked={checkedCommercialNo}
                                                        clickHandler={this.setCheckedCommercialNo}
                                                    />
                                                </div>
                                            </div>
                                            :
                                            null
                                    }
                                </div>
                                <Checkbox
                                    title={eligibleData.options[1].title}
                                    checked={checkedPartA}
                                    clickHandler={this.setCheckedPartA}
                                />
                                <Checkbox
                                    title={eligibleData.options[2].title}
                                    checked={checkedPartAB}
                                    clickHandler={this.setCheckedPartAB}
                                />
                                {
                                    group === 3 ?
                                        <div
                                            className={checkedPartABD ? "question-sub-content checked" : "question-sub-content"}>
                                            <Checkbox
                                                title={eligibleData.options[3].title}
                                                checked={checkedPartABD}
                                                clickHandler={this.setCheckedPartABD}
                                            />
                                            <div className="clearfix"/>
                                            {
                                                checkedPartABD ?
                                                    <div className="qualification-content wow fadeInDown"
                                                         data-wow-duration=".5s">
                                                        <h1 className="question-title text-center">
                                                            {eligibleData.options[3].annual_income.question + this.calculateNecessaryIncome() + "?"}
                                                        </h1>
                                                        <div className="question-content">
                                                            <Checkbox
                                                                title={eligibleData.options[3].annual_income.options[0].title}
                                                                checked={checkedPartABDYes}
                                                                clickHandler={this.setCheckedPartABDYes}
                                                            />
                                                            <Checkbox
                                                                title={eligibleData.options[3].annual_income.options[1].title}
                                                                checked={checkedPartABDNo}
                                                                clickHandler={this.setCheckedPartABDNo}
                                                            />
                                                        </div>
                                                    </div>
                                                    :
                                                    null
                                            }
                                            <div className="clearfix"/>
                                            {
                                                checkedPartABD && checkedPartABDYes ?
                                                    <div className="qualification-sub-content wow fadeInDown"
                                                         data-wow-duration=".5s">
                                                        <h1 className="question-title text-center">
                                                            {eligibleData.options[3].sub2.question}
                                                        </h1>
                                                        <div className="question-content">
                                                            <Checkbox
                                                                title={eligibleData.options[3].sub2.options[0].title}
                                                                checked={checkedPartABDSubYes}
                                                                clickHandler={this.setCheckedPartABDSubYes}
                                                            />
                                                            <Checkbox
                                                                title={eligibleData.options[3].sub2.options[1].title}
                                                                checked={checkedPartABDSubNo}
                                                                clickHandler={this.setCheckedPartABDSubNo}
                                                            />
                                                        </div>
                                                    </div>
                                                    :
                                                    null
                                            }
                                            <div className="clearfix"/>
                                            {
                                                checkedPartABD && checkedPartABDNo ?
                                                    <div className="qualification-sub-sub-content wow fadeInDown"
                                                         data-wow-duration=".5s">
                                                        <h1 className="question-title text-center">
                                                            {eligibleData.options[3].sub3.question}
                                                        </h1>
                                                        <div className="question-content">
                                                            <Checkbox
                                                                title={eligibleData.options[3].sub3.options[0].title}
                                                                checked={checkedPartABDSub2Yes}
                                                                clickHandler={this.setCheckedPartABDSub2Yes}
                                                            />
                                                            <Checkbox
                                                                title={eligibleData.options[3].sub3.options[1].title}
                                                                checked={checkedPartABDSub2No}
                                                                clickHandler={this.setCheckedPartABDSub2No}
                                                            />
                                                        </div>
                                                    </div>
                                                    :
                                                    null
                                            }
                                            <div className="clearfix"/>
                                            {
                                                checkedPartABD && checkedPartABDYes && checkedPartABDSubYes ?
                                                    <div className="qualification-sub-sub-content wow fadeInDown"
                                                         data-wow-duration=".5s">
                                                        <h1 className="question-title text-center">
                                                            {eligibleData.options[3].sub3.question}
                                                        </h1>
                                                        <div className="question-content">
                                                            <Checkbox
                                                                title={eligibleData.options[3].sub3.options[0].title}
                                                                checked={checkedPartABDSub2Yes}
                                                                clickHandler={this.setCheckedPartABDSub2Yes}
                                                            />
                                                            <Checkbox
                                                                title={eligibleData.options[3].sub3.options[1].title}
                                                                checked={checkedPartABDSub2No}
                                                                clickHandler={this.setCheckedPartABDSub2No}
                                                            />
                                                        </div>
                                                    </div>
                                                    :
                                                    null
                                            }
                                        </div>
                                        :
                                        <Checkbox
                                            title={eligibleData.options[3].title}
                                            checked={checkedPartABD}
                                            clickHandler={this.setCheckedPartABD}
                                        />
                                }
                                <Checkbox
                                    title={eligibleData.options[4].title}
                                    checked={checkedMedicaid}
                                    clickHandler={this.setCheckedMedicaid}
                                />
                                <Checkbox
                                    title={eligibleData.options[5].title}
                                    checked={checkedOther}
                                    clickHandler={this.setCheckedOther}
                                />
                                <Checkbox
                                    title={eligibleData.options[6].title}
                                    checked={checkedNone}
                                    clickHandler={this.setCheckedNone}
                                />
                            </div>
                        </Fade>
                        :
                        null
                }
            </div>
        )
    }
}